import { Box, Group, Text, Stack, NumberInput, ActionIcon } from "@mantine/core";
import { Button } from "@xplatform/design-system";
import { IconPlus, IconX } from "@tabler/icons-react";
import type { PricingTier } from "../../utils/modelModalHelper";

interface ModelTierEditorProps {
    type: "input" | "output";
    tiers: PricingTier[];
    onAdd: () => void;
    onRemove: (i: number) => void;
    onUpdate: (i: number, field: keyof PricingTier, val: number | "") => void;
}

export const ModelTierEditor = ({
    type,
    tiers,
    onAdd,
    onRemove,
    onUpdate,
}: ModelTierEditorProps) => {
    const label = type === "input" ? "Input Token Tiers" : "Output Token Tiers";
    return (
        <Box>
            <Group justify="space-between" mb={6}>
                <Text size="sm" fw={600}>
                    {label}
                </Text>
                <Button
                    size="xs"
                    variant="subtle"
                    leftSection={<IconPlus size={12} />}
                    onClick={onAdd}
                >
                    Add Tier
                </Button>
            </Group>
            <Group gap={4} mb={4} px={2}>
                <Text size="xs" c="dimmed" style={{ flex: 1 }}>
                    Start
                </Text>
                <Text size="xs" c="dimmed" style={{ flex: 1 }}>
                    End
                </Text>
                <Text size="xs" c="dimmed" style={{ flex: 1 }}>
                    Price / 1M
                </Text>
                <Box w={28} />
            </Group>
            <Stack gap={4}>
                {tiers.map((tier, i) => (
                    <Group key={i} gap={4} align="center">
                        <NumberInput
                            placeholder="0"
                            min={0}
                            size="xs"
                            style={{ flex: 1 }}
                            value={tier.tierStart}
                            onChange={(v) => onUpdate(i, "tierStart", v as number | "")}
                        />
                        <NumberInput
                            placeholder="∞"
                            min={0}
                            size="xs"
                            style={{ flex: 1 }}
                            value={tier.tierEnd}
                            onChange={(v) => onUpdate(i, "tierEnd", v as number | "")}
                        />
                        <NumberInput
                            placeholder="0.50"
                            min={0}
                            decimalScale={6}
                            step={0.01}
                            size="xs"
                            style={{ flex: 1 }}
                            value={tier.price}
                            onChange={(v) => onUpdate(i, "price", v as number | "")}
                        />
                        <ActionIcon
                            size="sm"
                            color="red"
                            variant="subtle"
                            disabled={tiers.length === 1}
                            onClick={() => onRemove(i)}
                        >
                            <IconX size={12} />
                        </ActionIcon>
                    </Group>
                ))}
            </Stack>
        </Box>
    );
};
